module.exports = __webpack_public_path__ + "img/Refinancia.bbd9f8b6.svg";